import { eventTracker } from '@/config/trackingFunctions'
import { PAYMENT_FLOW_EVENTS, type PaymentFlowEventTypes } from '@/constants/TrackingConstants'

import { useUserDetails } from '@/hooks/useUserDetails'
import { useMemo } from 'react'

import { Subscription } from '@/types'

import { useAppSelector } from '@/hooks/useRedux'
import { userSelector } from '../user/selectors'
import { useSearchParams } from 'react-router-dom'

export function trackPaymentFlow(
  event: PaymentFlowEventTypes,
  subscriptions: Array<Subscription> = [],
  clientKey: string | null = null,
  userDetails: object = {}
) {
  switch (event) {
    case PAYMENT_FLOW_EVENTS.PAYMENT_NOOP:
    case PAYMENT_FLOW_EVENTS.PAYMENT_COMPLETED_SUCCESS:
      postEventToWindow({ status: 'success', subscriptions: subscriptions })
      break
    case PAYMENT_FLOW_EVENTS.PAYMENT_COMPLETED_ERROR:
      postEventToWindow({ status: 'error', subscriptions: subscriptions })
      break

    case PAYMENT_FLOW_EVENTS.PAYMENT_STARTED:
      postEventToWindow({ status: 'started', subscriptions: subscriptions })
      break
    case PAYMENT_FLOW_EVENTS.PAYMENT_ABORTED:
      postEventToWindow({ status: 'aborted', subscriptions: subscriptions })
      break
    default:
      postEventToWindow({ status: 'error', subscriptions: subscriptions })
      break
  }

  eventTracker(event, {
    partnerId: clientKey,
    ...userDetails,
  })
}

export function useTrackPaymentFlow() {
  const [searchParams] = useSearchParams()
  const clientKey = searchParams.get('clientKey')
  const { subscriptions } = useAppSelector(userSelector)

  const userDetails = useUserDetails()

  return useMemo(() => {
    return (event: PaymentFlowEventTypes) => trackPaymentFlow(event, subscriptions, clientKey, userDetails)
  }, [subscriptions, clientKey, userDetails])
}

function postEventToWindow(event: object) {
  window.parent.postMessage(event, '*')
}
